import { Dispatch } from 'redux';
import { getFeedbackData } from '@services/feedbackService';
import { feedbackActionTypes } from './actionTypes/feedback';
import { failure, loading } from './commonActions';
import { FeedbackResponseInterface } from '@types';

export const setFeedbackData = (payload: FeedbackResponseInterface) => {
  return {
    type: feedbackActionTypes.SET_FEEDBACK_DATA,
    payload,
  };
};

export const setFeedbackDataIsLoading = (isLoading: boolean) => {
  return {
    type: feedbackActionTypes.FEEDBACK_DATA_LOADING,
    payload: isLoading,
  };
};

export const makeFeedbackData = () => {
  const instanceName = 'feedback_data';

  return async (dispatch: Dispatch) => {
    try {
      dispatch(loading(true, instanceName));
      dispatch(setFeedbackDataIsLoading(true));

      const feedbackResponse = await getFeedbackData();

      dispatch(setFeedbackData(feedbackResponse));
    } catch (err) {
      dispatch(failure(true, instanceName));
    } finally {
      dispatch(loading(true, instanceName));
    }
  };
};
